import { Injectable } from "@angular/core";

class CitLicenseSummaryItem {
  public PropertyName: string;
  public PropertyValue: any;
}


class LicenseSummaryModel {
  public Historian: any;
  public Scada: any;
  public SiteId: string;
  public TimeLimitedEndDate: Date;
  public TimeLimitedStartDate: Date;
}

class AuthCodeModel {
  public AuthorizationCode: string;
  public AuthorizationCodeCitect: string;
  public AuthorizationCodeVijeo: string;

  public AuthorizationCodeHash: string;
  public AuthorizationCodeCitectHash: string;
  public AuthorizationCodeVijeoHash: string;
}

class UpgradeAPIErrorModel {
  public Code: Number;
  public Message: string;
}



export class LicenseSummaryResponseModel {

  licenseSummary: LicenseSummaryModel;
  authCode: AuthCodeModel;
  upgradeAPIError: UpgradeAPIErrorModel;
  errorMessage: any;
  isError: boolean;
  showRequestAuthCode: boolean;
  siteId: string;
  keySerialNumber: string;
  keySerialNumberHash: string;
  activationId: string;
}


export class AuthCodeEmailModel {

  AuthorizationCode: string;
  AuthorizationCodeCitect: string;
  AuthorizationCodeVijeo: string;

  AuthorizationCodeHash: string;
  AuthorizationCodeCitectHash: string;
  AuthorizationCodeVijeoHash: string;

  Email: string;
  KeySerialNumber: string;
  KeySerialNumberHash: string;
}


export class RequestAuthCodeORVersionUpgradeModel {

  public USBKeySerialNumber: string;
  public ContactName: string;
  public ContactEmail: string;
  public Company: string;
  public ProductType: string;
  public ActivationId: string;
  public SiteId: string;

}
export class UserInfo {

  public UserName: string;
  public Email: string;
}

export const productArray = [
  {
    value: "",
    displayValue: "Select Product"
  },
  {
    value: "citect",
    displayValue: "Citect SCADA / Citect Historian"
  },
  {
    value: "se",
    displayValue: "PES / PowerSCADA"
  }
]
